import { getRetailer } from "@faire/marketplace-lib/serialized-data/getRetailer";
import React, { createContext, useContext, useMemo } from "react";
import { createStore, StoreApi, useStore } from "zustand";

import { useRetailerCoreWithSelector } from "./RetailerCoreProvider";

interface RetailerHighReturner {
  shouldShowHighReturnerOrderNudges: boolean;
}

const RetailerHighReturnerContext = createContext<
  StoreApi<RetailerHighReturner> | undefined
>(undefined);

export const RetailerHighReturnerProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const initialRetailer = getRetailer();
  const retailer = useRetailerCoreWithSelector((state) => state.retailer);
  const store = useMemo(
    () =>
      createStore<RetailerHighReturner>(() => ({
        shouldShowHighReturnerOrderNudges: !!(
          retailer?.is_high_returner ?? initialRetailer?.is_high_returner
        ),
      })),
    [retailer?.is_high_returner, initialRetailer?.is_high_returner]
  );

  return (
    <RetailerHighReturnerContext.Provider value={store}>
      {children}
    </RetailerHighReturnerContext.Provider>
  );
};

export const useShouldShowHighReturnerOrderNudges = () => {
  const context = useContext(RetailerHighReturnerContext);
  if (!context) {
    throw new Error(
      "RetailerHighReturnerContext not found. Must be used within RetailerHighReturnerProvider"
    );
  }
  return useStore(context);
};
